// import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Button, Dropdown, Input } from "antd";
// import { DownOutlined } from "@ant-design/icons";

// import { selectAuth, setLimitAction } from "features/auth/authSlice";
// import { useAuth } from "backend/useAuth";

const PageLimitDropDown = () => {
  return (null)
  // const dispatch = useDispatch();
  // const { updateUserProfile } = useAuth();
  // const { user } = useSelector(selectAuth);

  // const limits = [
  //   // { limit: 1 },
  //   { limit: 10 },
  //   { limit: 20 },
  //   { limit: 50 },
  //   { limit: 100 },
  // ];

  // // console.log(user)
  // const saveLimit = () => {
  //   updateUserProfile({ limit: user.limit })
  //     .then(() => {
  //       dispatch(setLimitAction({ limit: user.limit }));
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // const items = limits.map((option) => ({
  //   key: option.limit,
  //   label: `Items per page ${option.limit}`,
  //   onClick: () => dispatch(setLimitAction({ limit: option.limit })),
  // }));

  // return (
  //   <Input.Group compact>
  //     <Dropdown menu={{ items }} trigger={["click"]}>
  //       <Button className="border-primary">
  //         Views per page {user.limit} <DownOutlined />
  //       </Button>
  //     </Dropdown>
  //     <Button type="primary" onClick={saveLimit}>
  //       Save
  //     </Button>
  //   </Input.Group>
  // );
};

export default PageLimitDropDown;
